export class RegistrationHealthElement {

  AdmissionHealthDrugTestId:number;
  AdmissionHealthId:number;

  AdmissionMasterId:number;
  Height:string;
  WeightStandard:string;
  Weight:string;

  Waist:string;
  HealthIssue:string;
  UnderTreatment:string;
  PracticeDeepSleep:string;
  PracticeSleepHr:string;
  PracticeDailyWater:string;
  PracticeFoodHabit:number;
  PracticeAddiction:string;

  DrugTestId:number;
  DrugTestDate:string; IsTestDatePresent:string;
  DrugRemarks:string;

  OperationType :string;
  CreatedBy :number;
  MachineIP :string;
  Notes:string;

  }
